// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","InstagramEmbed":"bax_a","InstagramEmbed__mask":"bax_b bhr_bi bhr_bo bhr_wz"};